<!-- Spacer -->
<div
    class="fuse-vertical-navigation-item-wrapper mx-1 my-0"
    [ngClass]="item.classes?.wrapper"
></div>
